import type { FilterConfig } from '#types/config/components/filter'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    selected: 'bg-grey-10 b-grey-10',
  }
} satisfies RecursivePartial<FilterConfig['option']['tileSquare']>
